import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Works\ExhibitionController::store
* @see app/Http/Controllers/Works/ExhibitionController.php:25
* @route '/works/{work}/exhibitions'
*/
export const store = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/works/{work}/exhibitions',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Works\ExhibitionController::store
* @see app/Http/Controllers/Works/ExhibitionController.php:25
* @route '/works/{work}/exhibitions'
*/
store.url = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { work: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { work: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            work: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
    }

    return store.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\ExhibitionController::store
* @see app/Http/Controllers/Works/ExhibitionController.php:25
* @route '/works/{work}/exhibitions'
*/
store.post = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\ExhibitionController::store
* @see app/Http/Controllers/Works/ExhibitionController.php:25
* @route '/works/{work}/exhibitions'
*/
const storeForm = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\ExhibitionController::store
* @see app/Http/Controllers/Works/ExhibitionController.php:25
* @route '/works/{work}/exhibitions'
*/
storeForm.post = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Works\ExhibitionController::update
* @see app/Http/Controllers/Works/ExhibitionController.php:38
* @route '/works/{work}/exhibitions/{exhibition}'
*/
export const update = (args: { work: string | { slug: string }, exhibition: number | { id: number } } | [work: string | { slug: string }, exhibition: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/works/{work}/exhibitions/{exhibition}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Works\ExhibitionController::update
* @see app/Http/Controllers/Works/ExhibitionController.php:38
* @route '/works/{work}/exhibitions/{exhibition}'
*/
update.url = (args: { work: string | { slug: string }, exhibition: number | { id: number } } | [work: string | { slug: string }, exhibition: number | { id: number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            work: args[0],
            exhibition: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
        exhibition: typeof args.exhibition === 'object'
        ? args.exhibition.id
        : args.exhibition,
    }

    return update.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace('{exhibition}', parsedArgs.exhibition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\ExhibitionController::update
* @see app/Http/Controllers/Works/ExhibitionController.php:38
* @route '/works/{work}/exhibitions/{exhibition}'
*/
update.put = (args: { work: string | { slug: string }, exhibition: number | { id: number } } | [work: string | { slug: string }, exhibition: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Works\ExhibitionController::update
* @see app/Http/Controllers/Works/ExhibitionController.php:38
* @route '/works/{work}/exhibitions/{exhibition}'
*/
const updateForm = (args: { work: string | { slug: string }, exhibition: number | { id: number } } | [work: string | { slug: string }, exhibition: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\ExhibitionController::update
* @see app/Http/Controllers/Works/ExhibitionController.php:38
* @route '/works/{work}/exhibitions/{exhibition}'
*/
updateForm.put = (args: { work: string | { slug: string }, exhibition: number | { id: number } } | [work: string | { slug: string }, exhibition: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Works\ExhibitionController::destroy
* @see app/Http/Controllers/Works/ExhibitionController.php:49
* @route '/works/{work}/exhibitions/{exhibition}'
*/
export const destroy = (args: { work: string | { slug: string }, exhibition: number | { id: number } } | [work: string | { slug: string }, exhibition: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/works/{work}/exhibitions/{exhibition}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Works\ExhibitionController::destroy
* @see app/Http/Controllers/Works/ExhibitionController.php:49
* @route '/works/{work}/exhibitions/{exhibition}'
*/
destroy.url = (args: { work: string | { slug: string }, exhibition: number | { id: number } } | [work: string | { slug: string }, exhibition: number | { id: number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            work: args[0],
            exhibition: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
        exhibition: typeof args.exhibition === 'object'
        ? args.exhibition.id
        : args.exhibition,
    }

    return destroy.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace('{exhibition}', parsedArgs.exhibition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\ExhibitionController::destroy
* @see app/Http/Controllers/Works/ExhibitionController.php:49
* @route '/works/{work}/exhibitions/{exhibition}'
*/
destroy.delete = (args: { work: string | { slug: string }, exhibition: number | { id: number } } | [work: string | { slug: string }, exhibition: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Works\ExhibitionController::destroy
* @see app/Http/Controllers/Works/ExhibitionController.php:49
* @route '/works/{work}/exhibitions/{exhibition}'
*/
const destroyForm = (args: { work: string | { slug: string }, exhibition: number | { id: number } } | [work: string | { slug: string }, exhibition: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\ExhibitionController::destroy
* @see app/Http/Controllers/Works/ExhibitionController.php:49
* @route '/works/{work}/exhibitions/{exhibition}'
*/
destroyForm.delete = (args: { work: string | { slug: string }, exhibition: number | { id: number } } | [work: string | { slug: string }, exhibition: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\Works\ExhibitionController::reorder
* @see app/Http/Controllers/Works/ExhibitionController.php:56
* @route '/works/{work}/exhibitions/reorder'
*/
export const reorder = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: reorder.url(args, options),
    method: 'patch',
})

reorder.definition = {
    methods: ["patch"],
    url: '/works/{work}/exhibitions/reorder',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Works\ExhibitionController::reorder
* @see app/Http/Controllers/Works/ExhibitionController.php:56
* @route '/works/{work}/exhibitions/reorder'
*/
reorder.url = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { work: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { work: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            work: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
    }

    return reorder.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\ExhibitionController::reorder
* @see app/Http/Controllers/Works/ExhibitionController.php:56
* @route '/works/{work}/exhibitions/reorder'
*/
reorder.patch = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: reorder.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Works\ExhibitionController::reorder
* @see app/Http/Controllers/Works/ExhibitionController.php:56
* @route '/works/{work}/exhibitions/reorder'
*/
const reorderForm = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reorder.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\ExhibitionController::reorder
* @see app/Http/Controllers/Works/ExhibitionController.php:56
* @route '/works/{work}/exhibitions/reorder'
*/
reorderForm.patch = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reorder.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

reorder.form = reorderForm

const exhibitions = {
    store: Object.assign(store, store),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    reorder: Object.assign(reorder, reorder),
}

export default exhibitions